<template>
  <Layout>
    <ServerStatusListPage
      title="Verified Applications"
      subtitle="Identity and documents confirmed by a verification officer, awaiting final approval."
      card-title="Verified"
      icon="shield-check"
      tone="teal"
      by-label="Verified By"
      search-placeholder="Search verified application..."
      empty-message="No verified applications"
      endpoint="/applications/all_application_details/"
      status="verified"
      server-status-filter
    />
  </Layout>
</template>

<script>
import Layout from "../../layouts/main";
import ServerStatusListPage from "@/components/shared/ServerStatusListPage.vue";

// Admin: applications whose status is "verified". Paged, searched and sorted on the server;
// page / search / sort stay in the URL.
export default {
  components: {
    Layout,
    ServerStatusListPage,
  },
};
</script>